class SiderbarFilter extends HTMLElement {
    constructor() {
        super();
        this.dropdown = this.querySelectorAll('.dropdown-btn');
        console.log(this.dropdown);
        this.dropdown.forEach(e => {
            e.addEventListener('click', function() {
               e.classList.toggle('active');
                var dropdownContent = e.nextElementSibling;
                var arrowdown = e.children[0];
                if (dropdownContent.style.display === 'block') {
                    dropdownContent.style.display = 'none';
                    arrowdown.style.transform = 'rotate(0deg)';
                } else {
                    dropdownContent.style.display = 'block';
                    arrowdown.style.transform = 'rotate(180deg)';
                }
            })
        })
    }
}
customElements.define('sidebar-filter', SiderbarFilter)
